export default {
    "id": "finddoc-club",
    "name": "FindDoc Club",
    "style": "link",
    "href": "https://www.finddoc.com/club"
}